import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMobileScreen,
  faQrcode,
  faUtensils,
  faBell,
} from "@fortawesome/free-solid-svg-icons";

const OrdersPage = () => {
  return (
    <div className="max-w-6xl mx-auto p-6">
      <div className="flex items-center gap-4 mb-8">
        <span className="text-4xl">🍽️</span>
        <h1 className="text-3xl font-bold">Order & Reservations System</h1>
      </div>

      <div className="grid md:grid-cols-2 gap-8">
        <div>
          <img
            src="https://images.unsplash.com/photo-1555396273-367ea4eb4db5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80"
            alt="Order System"
            className="rounded-lg shadow-md w-full h-64 object-cover"
          />

          <div className="mt-6 bg-white p-6 rounded-lg shadow-sm border border-gray-100">
            <h2 className="text-xl font-semibold mb-4">System Features</h2>
            <div className="space-y-4">
              <div className="flex items-center gap-3">
                <FontAwesomeIcon
                  icon={faMobileScreen}
                  className="text-blue-500"
                />
                <span>Mobile-friendly interface</span>
              </div>
              <div className="flex items-center gap-3">
                <FontAwesomeIcon icon={faQrcode} className="text-green-500" />
                <span>QR code ordering</span>
              </div>
              <div className="flex items-center gap-3">
                <FontAwesomeIcon
                  icon={faUtensils}
                  className="text-orange-500"
                />
                <span>Menu management</span>
              </div>
              <div className="flex items-center gap-3">
                <FontAwesomeIcon icon={faBell} className="text-yellow-500" />
                <span>Real-time notifications</span>
              </div>
            </div>

            <div className="mt-6 pt-6 border-t border-gray-200">
              <div className="flex justify-between items-center">
                <span className="font-medium">Monthly Subscription</span>
                <span className="font-bold text-lg">15,000 MMK</span>
              </div>
              <button className="mt-4 w-full bg-black text-white py-3 rounded-lg font-medium hover:bg-gray-800 transition">
                Get Started
              </button>
            </div>
          </div>
        </div>

        <div>
          <h2 className="text-2xl font-semibold mb-4">How It Works</h2>

          <div className="space-y-6">
            <div className="flex gap-4">
              <div className="bg-black text-white rounded-full w-8 h-8 flex items-center justify-center flex-shrink-0">
                1
              </div>
              <div>
                <h3 className="font-medium">Customer Scans QR Code</h3>
                <p className="text-gray-600">
                  Place QR codes on tables for easy access to your menu
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <div className="bg-black text-white rounded-full w-8 h-8 flex items-center justify-center flex-shrink-0">
                2
              </div>
              <div>
                <h3 className="font-medium">Browse & Order</h3>
                <p className="text-gray-600">
                  Customers select items and customize their orders
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <div className="bg-black text-white rounded-full w-8 h-8 flex items-center justify-center flex-shrink-0">
                3
              </div>
              <div>
                <h3 className="font-medium">Kitchen Receives Order</h3>
                <p className="text-gray-600">
                  Orders appear instantly on your kitchen display system
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <div className="bg-black text-white rounded-full w-8 h-8 flex items-center justify-center flex-shrink-0">
                4
              </div>
              <div>
                <h3 className="font-medium">Order Fulfillment</h3>
                <p className="text-gray-600">
                  Staff prepares and delivers the order to the customer
                </p>
              </div>
            </div>
          </div>

          <div className="mt-8 bg-blue-50 p-6 rounded-lg">
            <h3 className="font-semibold text-lg mb-2">Reservation System</h3>
            <p className="text-gray-700 mb-4">
              Manage table bookings with our integrated reservation system
            </p>
            <img
              src="https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80"
              alt="Restaurant reservation"
              className="rounded-lg w-full h-40 object-cover"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrdersPage;
